const discount = {
  joinAccount: 'Sign Up',
  loginAccount: 'Sign in',
  nextTime: 'I\'m not interested now',
  applyEvent: 'Apply the event',
  alreadyApplied: 'Already applied',
  startLottery: 'Start to draw',
  stopLottery: 'Stop',
  congratulation: 'Congratulations!',
  findAccountCoupon: 'Got %{amount} discount. You can find it at your Account page',
  coupons: 'Coupons',
  amount: 'Amount',
  couponCode: 'Code',
  activatedPeriod: 'Activated Period',
  expireOn: 'Expire on %{date}',
  used: 'Used?',
  ntd: 'NTD',
  shareToFB: 'Share to facebook',
  useCoupon: 'Use coupon',
  useCouponDiscount: 'Use the coupon with %{amount} discounted',
  inputCouponCode: 'Input the discount code',
}

const traffic = {
  trafficInfo: 'Traffic Information',
  howToArrive: 'How to arrive in %{location}?',
  AIR: 'Airline',
  RAILWAY: 'Railway',
  CAR: 'Driving',
  SHIP: 'Ship',
  RELATED: 'Related Information',
}

const shop = {
  intro: 'Introduction',
  address: 'Address',
  certSystem: 'Certification System',  
  businessHours: 'Business Hours',
  detail: 'Detail',
  setup: 'Since %{year}',
  others: 'Others',
  // Diving Services
  discoverScubaDiving: 'Discover Dive',
  diveCourse: 'Certification Course',
  freeDiving: 'Free Dive',
  techDiving: 'Tech Dive',
  childrenDiving: 'Junior Dive',
  shoreDive: 'Shore Dive',
  boatDive: 'Boat Dive',
  nitrox: 'Nitrox / Enriched Air',
  professionalPhotographyDiveGuide: 'Pro-Level Photographer Dive Guide',
  equipmentRental: 'Equipment Rental',
  underwaterCameraRental: 'Underwater Camera Rental',
  diverPropulsionVehicleRental: 'DPV (Sub-Scooter) Rental',
  underwaterPhotographyService: 'Underwater Photographing Service',
  // Other Services
  accommodations: 'Accommodation',
  chineseService: 'Chinese Service',
  englishService: 'English Service',
  freeWifi: 'Free Wifi',
  hotShower: 'Hot Shower',
  ferryTicketBooking: 'Ferry Ticket Booking',
  motorcycleRental: 'Motorcycle Rental',
  bicycleRental: 'Bicycle Rental',
  dining: 'Meal Service',
  snorkelling: 'Snorkel',
  nightFishing: 'Night Fishing',
  ecoTours: 'Eco-Tours',
  intertidalZoneNightTourUnchartedSpotExploration: 'Night tours to intertidal zone/secret hideout discovering',
}

const activity = {
  addons: 'Addons',
  lastFor: 'Activity Duration',
  minute: 'minutes',
  hour: 'hour(s)',
  day: 'day(s)',
  activityIntro: 'Activity Info',
  activityFlow: 'Activity Itinerary',
  activityContents: 'Activity Incl.',
  courseStructure: 'Course Structure',  
  activityLimitations: 'Participation Requirement',
  pricePackages: 'Price Packages',
  activityNotices: 'Important Notices',
  cancelRules: 'Cancellation Policy',
  none: 'None',
  oneTime: '1-10 times',
  decadeTimes: '11-50 times',
  fiftyTimes: '51-100 times',
  hundredTimes: 'Over 100 times',
  activity_coming_soon: 'The activity is coming soon ',
  booked: 'Booked',
  requireTimeSection: 'No Section Selected',
  plzSelectTimeSection: 'Please choose the section you would like to attend',
  not_business_day: 'Not business day',
}

const order = {
  unconfirm: 'Unconfirm',
  confirmed: 'Confirmed',
  unpaid: 'Unpaid',
  paid: 'Paid',
  cancelled: 'Cancelled',
  orderConfirm: 'Confirm Order',
  confirmOrder: 'Confirm the order',
  inputEmailToConfrim: 'Input the email to confirm',
  incorrectEmail: 'Incorrect email',
  confirmOrderFailed: 'Failed to confirm the order',
  confirmOrderSuccess: 'Confirm Success',
  confirmOrderResult: 'Confirm the order %{orderNo} successfully',
  accountsPayable: 'The order amount',
  contactInfo: 'Contact information',
}

const en = {
  login: 'Log In',
  logout: 'Log Out',
  loginSuccess: 'Log in successfully',
  logoutSuccess: 'Log out successfully',
  plzLoginWithAccPwd: 'Please login with username and password',
  registerNewAccount: 'Register new account',
  register: 'Register',
  edit: 'Edit',
  changePassword: 'Change Password',
  saveChanges: 'Save Changes',
  or: 'or',
  forgotPassword: 'Forgot Password',
  plzInputEmail: 'Please Enter the Email',
  resetPasswordSent: 'The email to reset password has already been sent, please follow the instructions in the email to reset your password.',
  send: 'Send',
  youHaveNewMessages: 'You have new message(s)',
  plzGotoAccountToSeeIt: 'Please go to the account page to see it',
  backToAccount: 'Back to account page',
  cancel: 'Cancel',
  searchPlaceholder: 'Location：Green Island、Orchid Island...',
  currency: 'Currency',
  language: 'Language',
  home360: 'Hot 360',
  homeRecent: 'Latest 360',
  homeRecommend: 'Recommended Activities',  
  sortByHot: 'Sort By Hot',
  sortByUpdate: 'Sort By Last Update',
  homeInput: 'Where would you like to dive???',
  findActivity: 'Find Activity',
  findActivityAround: 'Find Activities Around You',
  find360Around: 'Find 360 Around You',
  findShopAround: 'Find Shops Around You',
  goMap: 'Check Location on the Map',
  divingDifficulty: 'Diving Difficulty',
  divingMethod: 'Diving Method',
  yourSearch: 'Your Search',
  filter: 'Filters',
  sortType: 'Sort',
  hotLevel: 'Hot',
  customerRecommendation: 'Recommendation',
  changeLocation: 'Change Location',
  difficulty: 'Difficulty',
  hard: 'Hard',
  medium: 'Medium',
  easy: 'Easy',
  type: 'Type',
  coastDiving: 'Coast Diving',
  boatDiving: 'Boat Diving',
  highOxygenDiving: 'High Oxygen Diving',
  divingServices: 'Diving Services',
  experincingDiving: 'Experiencing',
  licenseDiving: 'License',
  funDiving: 'Fun Dive',
  otherServices: 'Other Services',
  resident: 'Resident',
  shuttle: 'Shuttle Bus',
  languageSupport: 'Chinese/English Support',
  freeWifi: 'Free WIFI',
  hotShower: 'Shower Room',
  seePrice: 'Detail',
  record360: '360 Recording',
  chooseTimeSection: 'Choose Section...',
  assemblyPlace: 'Meeting Point',
  seeDetail: 'Detail',
  accountInfo: 'Account Information',
  yourOrder: 'Orders',
  yourFavorite: 'Favorite',
  yourMessage: 'Messages',  
  addFavoriteSuccess: 'Added to favorite successfully',
  removeFavoriteSuccess: 'Remove from favorites successfully',
  id: 'ID No.',
  passport: 'Passport No.',
  idOrPassport: 'ID or Passport Number',
  invalidNumber: 'Invalid',
  realName: 'Real Name',
  displayName: 'Display Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  name: 'Name',
  password: 'Password',
  confirmPassword: 'Confirm Password',
  gender: 'Gender',
  birthday: 'Birthday',
  contactPhone: 'Contact Number',
  email: 'E-Mail',
  updateAccountSuccess: 'Account information updated successfully',
  back: 'Back',
  allMessages: 'All',
  orderMessages: 'Order',
  activityQuestions: 'Activity',
  systemNotification: 'System',
  subject: 'Subject',
  view: 'View',
  sender: 'Sender',
  you: 'You',
  shop: 'The Shop',  
  close: 'Close',
  divingLicense: 'Diving License',
  divingExperience: 'Diving Experience',
  addToFavorite: 'Add to Favorite',
  removeFavorite: 'Remove from Favorite',  
  writeComment: 'Write Comments',
  yourComment: 'Your Comment',
  whole: 'Whole',
  profession: 'Profession',
  service: 'Service',
  comfort: 'Comfort',
  value: 'Value',
  title: 'Title',
  rating: 'Rating',
  sendComment: 'Send',
  sendCommentSuccss: 'Sending Comment Successfully',
  theComments: 'Comments',
  comments: ' comments',
  creator: 'Creator',
  createdTime: 'Created Time',
  noSuitableResult: 'No Suitable Result',
  activityName: 'Activity',
  content: 'Content',
  price: 'Price',
  minDivingExperience: 'Min. Diving Experience',
  orderNow: 'Order Now',
  askActivity: 'Question to this Activity',
  addShopToFavorite: 'Add the Shop into Favorite',
  removeShopFromFavorite: 'Remove the Shop from Favorite',
  message: 'Message',
  sendMessageSuccess: 'Send message successfully',
  sendMessageFailure: 'Send message failed',
  orderDate: 'Order Date',
  orderPersons: 'Number of Persons',
  order: 'Order',
  plzLoginFirst: 'Please login to continue',
  orderSuccess: 'Successfully ordered',
  orderNo: 'Order No.',
  orderDetail: 'Order Detail',
  cannotSelectPast: 'Cannot select past days',
  noActivitySelected: 'No event was selected',
  cancelOrder: 'Cancel Order',
  reOrder: 'Order Again',
  traveler: 'Traveler',
  travelerInfo: 'Traveler Information',
  travelInsurance: '*We have purchased travel insurance for guests who join this activity, please provide the guest information',
  sameAsCreator: 'Same as the Orderer',
  activity: 'Activity',
  date: 'Date',
  persons: 'Persons',
  charge: 'Charge',
  yourInfo: 'Account Information',
  phone: 'Phone',
  creditCardInfo: 'Credit Card Information',
  creditCardInfoComment: '*If you selected to pay on site, this is just to confirm your reservations, we will not charge you',
  cardType: 'Card Type',
  cardNo: 'Card No.',
  validThru: 'Valid Thru',
  securityCode: 'Security Code',
  orderCancelNotice: 'Cancellation Fee???*Waived for natural calamities',
  createOrderFailed: 'Create order failed',
  maxPeopleExceed: 'This section has been filled, please choose another section',
  confirmOrderPayArrived: 'Order confirmed',
  confirmOrderPayOnline: 'Order confirmed, pay online',
  payNow: 'Pay Now',
  orderSuccessResult: 'Please wait for the shop manager to confirm the order. The order number is %{orderNo}, you can look up at %{urOrders} for detail',
  confirmCancelOrder: 'Would you like to cancel the order ???',
  cancelOrderResult: 'The order %{orderNo} has been cancelled, thanks for ordering the activity',
  cancelOrderSuccess: 'The order cancelled successfully',
  unavailable: 'Unavailable',
  paymentNotAvailable: 'The payment methods are not active now? please try another methods',
  plzCompleteTravelerInfo: 'Please complete the travelers information',
  plzCompleteContactInfo: 'Please complete the contact information',
  incompleteData: 'Incomplete Information',
  
  have: 'Yes',
  haveNone: 'No',
  species: 'Species',
  terrain: 'Terrain',
  bestSeason: 'Best Season',
  about: 'About Us',  
  search: 'Search',
  showAED: 'Show AED',
  hideAED: 'Hide AED',
  position: 'Position',
  terms: 'Terms of Service',
  privacy: 'Privacy Policy',
  contact_support: 'Support',
  yes: 'Yes',
  no: 'No',
  ...discount,
  ...shop,
  ...activity,
  ...traffic,
  ...order,
}

export default en


// WEBPACK FOOTER //
// ./src/i18n/en.js